

























































































































import { mapActions } from 'vuex';
import {
  supportLanguages,
  setLanguage,
  Language,
} from '@/bootstrap/heplers/vue-i18n';
import Vue from 'vue';
import flagJa from '@/assets/icons/flags/ja.png';
import { Component, Ref } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import LanguagesIcon from '@/components/Helper/Icon/Svg/LanguagesIcon.vue';
import AuthenticationWrapper from '@/components/Layout/Layouts/AuthenticationWrapper.vue';
import flagVi from '../assets/icons/flags/vi.png';
import flagEn from '../assets/icons/flags/en.png';
import IconEnvelope from '../assets/icons/envelope.svg';
import IconPadLock from '../assets/icons/padlock.svg';

export interface LoginInfo {
  username: string;
  password: string;
}

@Component<Login>({
  components: { AuthenticationWrapper, LanguagesIcon },
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
})
export default class Login extends Vue {
  icons: Record<string, string> = {
    envelop: IconEnvelope,
    padLock: IconPadLock,
  };
  supportLanguages: Language[] = supportLanguages;
  lang: Language = undefined;
  flags: Record<Language, string> = {
    en: flagEn,
    vi: flagVi,
    ja: flagJa,
  };
  loginInfo: LoginInfo = {
    username: '',
    password: '',
  };
  rememberLogin = false;

  @Ref('form') readonly form!: InstanceType<typeof ValidationObserver>;

  fetchCurrentStaff!: () => Promise<void>;

  changeLanguage(lang: Language): void {
    setLanguage(this.$i18n, lang);
  }

  get isMobileSafari() {
    return this.$vuetify.breakpoint.mobile;
  }

  async login(): Promise<void> {
    try {
      const { username, password } = this.loginInfo;
      if (await this.$auth.login(username, password)) {
        if (this.rememberLogin) {
          localStorage.setItem('manager@rememberLogin', username);
        }
        await this.$router.push('/');
        await this.fetchCurrentStaff();
        await this.$store.dispatch('staff/historyLogin');
      } else {
        this.form.setErrors({
          username: this.$i18n.t('validation.wrongCredential') as string,
        });
      }
    } catch (e) {
      if (
        e?.response?.data?.message &&
        Array.isArray(e.response.data.message)
      ) {
        const errors: Record<string, string[]> = {};
        e.response.data.message.forEach(
          (message: { field: string; errors: string[] }) => {
            errors[message.field] = message.errors.map(
              (key: string) => this.$t(`validation.${key}`) as string,
            );
          },
        );
        this.form.setErrors(errors);
      }
    }
  }
}
